import { SelectorOption } from 'antd-mobile/es/components/selector';

import { InterventionJson, RateJson, PrestationEnum } from '../../../types/models';

export function getChoices(prestation_costs?: RateJson): Array<SelectorOption<PrestationEnum>> {
  const choices: Array<SelectorOption<PrestationEnum>> = [];
  if (prestation_costs?.decontamination) {
    choices.push({ label: 'Decont', value: 'decontamination' });
  }
  if (prestation_costs?.disinfection) {
    choices.push({ label: 'Desinf', value: 'disinfection' });
  }
  if (prestation_costs?.interior) {
    choices.push({ label: 'Int', value: 'interior' });
  }
  if (prestation_costs?.exterior) {
    choices.push({ label: 'Ext', value: 'exterior' });
  }
  if (prestation_costs?.package) {
    choices.push({ label: 'Pack', value: 'package' });
  }
  return choices;
}

export function findPrestationCost(costs: RateJson[], vehicle_type: string | undefined | null): RateJson | undefined {
  if (!vehicle_type) {
    return;
  }
  return costs.filter((c) => c.title === vehicle_type)[0];
}

const normalize = (s: string | null | undefined): string => (s || '').trim().toUpperCase();

export function findExpectedVehicleType(
  history: InterventionJson[],
  immat: string,
  parc: string,
  excludeId?: number,
): string | undefined {
  const wantImmat = normalize(immat);
  const wantParc = normalize(parc);
  if (!wantImmat && !wantParc) {
    return undefined;
  }

  const matches = history.filter((iv) => {
    if (excludeId !== undefined && iv.id === excludeId) {
      return false;
    }
    const ivImmat = normalize(iv.immatriculation);
    const ivParc = normalize(iv.parc_number);
    if (wantImmat && ivImmat === wantImmat) {
      return true;
    }
    if (wantParc && ivParc === wantParc) {
      return true;
    }
    return false;
  });

  if (matches.length === 0) {
    return undefined;
  }

  const counts = new Map<string, number>();
  matches.forEach((iv) => {
    const t = iv.prestation_costs?.title;
    if (t) {
      counts.set(t, (counts.get(t) || 0) + 1);
    }
  });

  let bestType: string | undefined;
  let bestCount = 0;
  counts.forEach((count, type) => {
    if (count > bestCount) {
      bestCount = count;
      bestType = type;
    }
  });
  return bestType;
}

export function findSameDayDuplicate(
  history: InterventionJson[],
  immat: string,
  parc: string,
  interventionTimestamp: string,
  excludeId?: number,
): InterventionJson | undefined {
  const wantImmat = normalize(immat);
  const wantParc = normalize(parc);
  if (!wantImmat && !wantParc) {
    return undefined;
  }
  const targetDate = (interventionTimestamp || '').slice(0, 10);
  if (!targetDate) {
    return undefined;
  }
  return history.find((iv) => {
    if (excludeId !== undefined && iv.id === excludeId) {
      return false;
    }
    const ivDate = (iv.timestamp || '').slice(0, 10);
    if (ivDate !== targetDate) {
      return false;
    }
    const ivImmat = normalize(iv.immatriculation);
    const ivParc = normalize(iv.parc_number);
    if (wantImmat && ivImmat === wantImmat) {
      return true;
    }
    if (wantParc && ivParc === wantParc) {
      return true;
    }
    return false;
  });
}
